var exports = {
  "d": "static__gMgcwx",
};

module.exports = exports;
